const strings = {
  labels: {
    title: 'Close and Classify Call',
    selectLabel: 'Call Reason',
    notesLabel: 'Notes',
    secondaryAction: 'Go back',
    primaryAction: 'Close and classify',
  },
  placeholders: {
    search: 'Search for Call Reason',
    notes: 'Additional details',
    select: 'Select',
  },
  errorBanner: {
    title: 'Call classification reasons cannot be loaded',
    primaryActionName: 'Retry',
  },
  writeClassificationToasts: {
    failedUpsert: 'Unable to close and classify call',
    failedAction: 'Close and Classify',
    successUpsert: 'Call completed',
  },
} as const;

export default strings;
